<div id="labs">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class=" inner-card">
                    <h4 class="card-title ">Laboratories</h4>
                    <div class="card-body text-justify">
                        <p class="text-justify inner-lead">Children are the fore-runners of a country and MPPS strives to nurture the best in them by tapping their potential in the most agreeable ambience. We firmly believe that a good lab not only makes science experiments fun but also help students achieve good academic results.</p>
                       <p class="inner-lead">We firmly believe that a good lab not only makes science experiments fun but also help students achieve good academic results.</p>
                        <p class="inner-lead font-weight-bold">We have fully equipped state-of-the-art labs for  Physics, Chemistry, Biology, Mathematics, Computer, Self Management and Art & Craft. <br> Children are regularly taken to the labs in groups. All the students, thus, get ample opportunities to understand the theoretical concepts by doing things practically.</p>
                        <div class="row">
                          <div class="col-6 text-center mb-4">
                            <a href="/assets/img/campus/labs/1.jpg" data-lightbox="Chemistry"><img src="/assets/img/campus/labs/1.jpg" alt="Chemistry" class="img-fluid rounded"></a>
                            <h5 class="text-center mt-4">Chemistry</h5>
                            </div>
                          
                          <div class="col-6 text-center mb-4">
                            <a href="/assets/img/campus/labs/3.jpeg" data-lightbox="Biology"><img src="/assets/img/campus/labs/3.jpeg" alt="Biology" class="img-fluid rounded"></a>
                            <h5 class="text-center mt-4">Biology</h5>
                            </div>
                          <div class="col-6 text-center mb-4">
                            <a href="/assets/img/campus/labs/4.jpg" data-lightbox="Physics"><img src="/assets/img/campus/labs/4.jpg" alt="Physics" class="img-fluid rounded"></a>
                            <h5 class="text-center mt-4">Physics</h5>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

       
    </div>
</div>